import { styled } from 'styled-components';

import { getMediaQuery } from '~/utils/responsive/media';

export const NotMobile = styled.div`
  display: none;

  ${getMediaQuery('tablet', 'laptop', 'desktop')} {
    display: block;
  }
`;

export const MobileOnly = styled.div`
  display: block;

  ${getMediaQuery('tablet', 'laptop', 'desktop')} {
    display: none;
  }
`;
